const validatePassword = password => {
  const re2 = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/;
  return re2.test(password);
};

export default validatePassword;